/* eslint-disable */
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../services/api';

// BUG-012: for someone who cannot get in (or has lost the verification email). Public, no sign-in needed. The server
// always gives the same answer whether or not the account exists, so this page never says which it was.
export default function ResendVerification() {
  const [identifier, setIdentifier] = useState('');
  const [loading, setLoading]       = useState(false);
  const [message, setMessage]       = useState('');
  const [error, setError]           = useState('');
  const navigate                    = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!identifier.trim()) return setError('Please enter your email address or username.');
    setLoading(true);
    try {
      const res = await authAPI.resendVerificationPublic(identifier.trim());
      setMessage(res.message || 'If that account exists and still needs verifying, a new verification email has been sent. Please check your inbox and spam folder.');
    } catch (err) {
      // Too many requests (429) or a network problem: say so plainly. Never anything about the account.
      setError(err?.error || 'Something went wrong. Please try again in a little while.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-logo">
          <img src="/casavello-stacked.png" alt="casavello" style={{ width: "140px", height: "auto", objectFit: "contain", marginBottom: "0.5rem" }} />
          <h1>casavello</h1>
          <p>Your entire property portfolio, effortlessly managed</p>
        </div>

        {message ? (
          <div style={{ textAlign: 'center', padding: '1rem 0' }}>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📧</div>
            <h2 style={{ color: 'var(--brand-green)', marginBottom: '0.5rem' }}>Check your inbox</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: '1.5rem', lineHeight: 1.6 }}>{message}</p>
            <button onClick={() => navigate('/login')} className="btn btn-primary" style={{ width: '100%', padding: '0.875rem', fontSize: '1rem' }}>
              Back to Login
            </button>
          </div>
        ) : (
          <>
            <div style={{ marginBottom: '1.5rem' }}>
              <h2 style={{ margin: '0 0 0.5rem', fontSize: '1.25rem' }}>Resend verification email</h2>
              <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: 1.5 }}>
                Enter your email address or username and we'll send a new verification link to the email address on the account. You can still sign in without verifying, but you will only be able to view your data until you do.
              </p>
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email address or username</label>
                <input type="text" value={identifier} onChange={e => setIdentifier(e.target.value)} placeholder="your@email.com" required autoFocus autoComplete="username" />
              </div>
              <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '0.875rem', fontSize: '1rem', marginTop: '0.5rem' }} disabled={loading}>
                {loading ? 'Sending...' : '📧 Resend verification email'}
              </button>
              <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                <button type="button" onClick={() => navigate('/login')} style={{ background: 'none', border: 'none', color: 'var(--brand-green)', cursor: 'pointer', textDecoration: 'underline', fontSize: '0.875rem' }}>
                  Back to Login
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
